import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';

/**
 * Componente para exibir a comparação dos valores de um campo, utilizado na análise de aditivos.
 *
 *  - valorAntes: string; // OBRIGATORIO
 *  - valorDepois: string; // OBRIGATORIO
 *  - valorExibicaoAntes?: string; // OPCIONAL
 *  - valorExibicaoDepois?: string; // OPCIONAL
 *
 * Caso os valores Antes e Depois sejam iguais, vai exibir apenas um parâmetro, sem destaque.
 * Caso sejam diferentes serão exibidos os parâmetros de antes e depois, com indicativos (ícone,
 * cor, tooltip) de que é informação anterior ou posterior (ao aditivo, no caso.)
 *
 * A informação a ser exibida segue a ordem, ignorando valores 'falsy' como string nula ou em branco:
 * valorExibicao* > valor* > "Não Informado"
 */
@Component({
  selector: 'detalhe-diferenca',
  templateUrl: './detalhe-diferenca.component.html',
  styleUrls: ['./detalhe-diferenca.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetalheDiferencaComponent implements OnChanges {
  @Input() valorAntes: string; // OBRIGATORIO
  @Input() valorDepois: string; // OBRIGATORIO
  @Input() valorExibicaoAntes?: string; // OPCIONAL
  @Input() valorExibicaoDepois?: string; // OPCIONAL

  igual: boolean;
  conteudoAntes: string;
  conteudoDepois: string;

  ngOnChanges(changes: SimpleChanges) {
    function firstNonNull(valorExibicao: string, valor: string): string {
      if (valorExibicao) {
        return valorExibicao;
      } else if (valor) {
        return valor;
      }
      return "Não Informado";
    }

    if (changes.valorAntes || changes.valorDepois) {
      this.igual = changes.valorAntes === changes.valorDepois;
    }

    if (changes.valorAntes || changes.valorExibicaoAntes) {
      this.conteudoAntes = firstNonNull(this.valorExibicaoAntes, this.valorAntes);
    }

    if (changes.valorDepois || changes.valorExibicaoDepois) {
      this.conteudoDepois = firstNonNull(this.valorExibicaoDepois, this.valorDepois);
    }
  }
}
